'use strict';

export const UPDATE_PRODUCT_UPGRADE_MODAL = 'UPDATE_PRODUCT_UPGRADE_MODAL';
export const UPDATE_PRODUCT_UPGRADE_MODAL_LOADING_STATUS = 'UPDATE_PRODUCT_UPGRADE_MODAL_LOADING_STATUS';

// 更新弹出框状态（显示、隐藏）
export function updateProductUpgradeModal(modalItme = null, visible = false, ) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_PRODUCT_UPGRADE_MODAL,
      modalItme,
      visible,
    });
  }
}

export function updateLoadingStatus(loading) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_PRODUCT_UPGRADE_MODAL_LOADING_STATUS,
      loading,
    });
  }
}